import React, { useState } from 'react';
import Modal from '../../../components/ui/Modal';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const ExportClientsModal = ({ isOpen, onClose, onExport }) => {
  const [exportOptions, setExportOptions] = useState({
    format: 'excel',
    category: 'all',
    status: 'all',
    dateRange: 'all',
    includeContactInfo: true,
    includePreferences: true,
    includeCommunicationHistory: false,
    includeMatchedProperties: false,
    includeDocuments: false,
    includeNotes: true
  });

  const handleChange = (field, value) => {
    setExportOptions(prev => ({ ...prev, [field]: value }));
  };

  const handleCheckbox = (field) => {
    setExportOptions(prev => ({ ...prev, [field]: !prev?.[field] }));
  };

  const handleExport = () => {
    onExport?.(exportOptions);
    onClose();
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      title="تصدير بيانات العملاء" 
      size="md"
      footer={null}
      icon={null}
      iconColor={null}
    >
      <div className="space-y-4">
        <div className="bg-slate-500/10 border border-slate-500/30 rounded-lg p-4 mb-4">
          <div className="flex items-center gap-2 text-slate-400">
            <Icon name="Download" size={20} />
            <span className="font-semibold">خيارات التصدير</span>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">صيغة الملف</label>
          <Select
            value={exportOptions?.format}
            onChange={(e) => handleChange('format', e?.target?.value)}
          >
            <option value="excel">Excel (.xlsx)</option>
            <option value="csv">CSV (.csv)</option>
            <option value="pdf">PDF (.pdf)</option>
            <option value="json">JSON (.json)</option>
          </Select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">فئة العملاء</label>
          <Select
            value={exportOptions?.category}
            onChange={(e) => handleChange('category', e?.target?.value)}
          >
            <option value="all">جميع الفئات</option>
            <option value="buyers">مشترون فقط</option>
            <option value="renters">مستأجرون فقط</option>
            <option value="investors">مستثمرون فقط</option>
            <option value="vip">VIP فقط</option>
          </Select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">حالة العملاء</label>
          <Select
            value={exportOptions?.status}
            onChange={(e) => handleChange('status', e?.target?.value)}
          >
            <option value="all">جميع الحالات</option>
            <option value="active">نشط فقط</option>
            <option value="pending">قيد المتابعة فقط</option>
            <option value="inactive">غير نشط فقط</option>
          </Select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">نطاق التاريخ</label>
          <Select
            value={exportOptions?.dateRange}
            onChange={(e) => handleChange('dateRange', e?.target?.value)}
          >
            <option value="all">جميع الفترات</option>
            <option value="today">اليوم</option>
            <option value="week">آخر أسبوع</option>
            <option value="month">آخر شهر</option>
            <option value="quarter">آخر 3 أشهر</option>
            <option value="year">آخر سنة</option>
          </Select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-3">البيانات المراد تضمينها</label>
          <div className="space-y-3">
            <Checkbox
              label="معلومات الاتصال (الاسم، البريد، الهاتف)"
              checked={exportOptions?.includeContactInfo}
              onChange={() => handleCheckbox('includeContactInfo')}
            />
            <Checkbox
              label="تفضيلات العقار والميزانية"
              checked={exportOptions?.includePreferences}
              onChange={() => handleCheckbox('includePreferences')}
            />
            <Checkbox
              label="سجل التواصل والمكالمات"
              checked={exportOptions?.includeCommunicationHistory}
              onChange={() => handleCheckbox('includeCommunicationHistory')}
            />
            <Checkbox
              label="العقارات المطابقة"
              checked={exportOptions?.includeMatchedProperties}
              onChange={() => handleCheckbox('includeMatchedProperties')}
            />
            <Checkbox
              label="المستندات المرفقة"
              checked={exportOptions?.includeDocuments}
              onChange={() => handleCheckbox('includeDocuments')}
            />
            <Checkbox
              label="الملاحظات والتعليقات"
              checked={exportOptions?.includeNotes}
              onChange={() => handleCheckbox('includeNotes')}
            />
          </div>
        </div>

        <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-3 mt-4">
          <div className="flex items-start gap-2 text-blue-400 text-sm">
            <Icon name="Info" size={16} className="mt-0.5 flex-shrink-0" />
            <p>سيتم تصدير البيانات وفقاً للخيارات المحددة. قد يستغرق التصدير بضع ثوانٍ حسب حجم البيانات.</p>
          </div>
        </div>

        <div className="flex gap-3 pt-4">
          <Button onClick={handleExport} className="flex-1">
            <Icon name="Download" size={18} className="ml-2" />
            تصدير الآن
          </Button>
          <Button onClick={onClose} variant="outline" className="flex-1">
            إلغاء
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ExportClientsModal;